module.exports = __webpack_public_path__ + "img/paperclip.8f95135b.svg";